<ng-container *ngIf="isMobile; else desktop">
  <ng-container *ngTemplateOutlet="activeOptionTemplate"></ng-container>
</ng-container>

<ng-template #desktop>
  <ng-container *ngIf="isResultsPage; else desktopTemplate">
    <ng-container *ngTemplateOutlet="activeOptionTemplate"></ng-container>
  </ng-container>
</ng-template>

<ng-template #desktopTemplate>
  <div class="background-input" *ngIf="showComponent" (click)="toggleInput()"></div>
  <app-search-bar-input
    [searchType]="searchType"
    *ngIf="!isResultsPage"
    [isPassengerField]=true
    [label]="passengerLabel | transloco"
    [value]="passengerArrangement | passengerInput : searchType : activeFlightClass"
    [icon]="iconByDevice"
    [id]="'passenger-input'"
    (isFocus)="toggleInput()">
  </app-search-bar-input>

  <div class="passengers-input-cont" *ngIf="showComponent">
    <ng-container *ngTemplateOutlet="passengerArrangment"></ng-container>
    <div class="line"></div>
    <ng-container *ngTemplateOutlet="flightClass"></ng-container>
    <div class="passengers-input-bottom-box">
      <app-ds-button
        [labels]="{ ButtonLabel: 'BUTTONS.APPLY' | transloco }"
        (clickEvent)="applySelection()">
      </app-ds-button>
    </div>
  </div>
</ng-template>

<ng-template #passengerArrangment>
  <div class="passengers-input-cont-box">
    <app-ds-typography
      [text]="'PASSENGERS' | transloco"
      [size]="typographyFontSize.XXS"
      [fontFamily]="typographyFontFamily.SemiBold"
      [color]="typographyColor.Primary">
    </app-ds-typography>
    <div *ngFor="let type of passengerArrangement" class="passenger-type-cont">
      <div class="passenger-type-label">
        <app-ds-typography
          [tag]="'p'"
          [text]="passengerArrangementTitle(type) | transloco"
          [size]="typographyFontSize.XXS"
          [color]="typographyColor.Primary">
        </app-ds-typography>
        <app-ds-typography
          [tag]="'p'"
          [text]="passengerArrangementLabel(type) | transloco"
          [size]="typographyFontSize.XXXS"
          [color]="typographyColor.Secondary">
        </app-ds-typography>
      </div>
      <app-search-bar-operator
        [selector]="'search-flight-'"
        [type]="type.id"
        [initialQuantity]="type.quantity"
        [searchBy]="searchBy"
        [totalPassengers]="totalPassengers"
        [maxPassengers]="maxPassengers"
        [passengerArrangement]="passengerArrangement"
        (quantityEmmiter)="updatePassengerArrangement($event, type)">
      </app-search-bar-operator>
    </div>
  </div>
</ng-template>

<ng-template #flightClass>
  <ng-container *ngIf="!isBus">
    <div [class.results]="isResultsPage" class="passengers-input-cont-box">
      <app-ds-typography
        [text]="'CLASS' | transloco"
        [size]="typographyFontSize.XXS"
        [fontFamily]="typographyFontFamily.SemiBold"
        [color]="typographyColor.Primary">
      </app-ds-typography>
      <div class="searchBarPassengerSelection__radio" *ngFor="let flightClass of flightClassTypes">
        <app-ds-radio-button
          [align]="radioButtonAlign"
          [checked]="isActiveClass(flightClass)"
          [title]="{ Label: 'SEARCH_MODULE.FLIGHT_CLASSES.' + flightClass | transloco }"
          (radioOnChecked)="selectFlightClass(flightClass)">
        </app-ds-radio-button>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #activeOptionTemplate>
  <ng-container [ngSwitch]="activeOption">
    <ng-container *ngSwitchCase="'PASSENGER_ARRANGEMENT'">
      <ng-container *ngTemplateOutlet="passengerArrangment"></ng-container>
      <div class="passengers-input-bottom-box">
        <app-ds-button
          [labels]="{ ButtonLabel: 'BUTTONS.APPLY' | transloco }"
          (clickEvent)="applySelection()">
        </app-ds-button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'FLIGHT_CLASSES'">
      <ng-container *ngTemplateOutlet="flightClass"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>
